/**
 * @author    Labs64 <netlicensing@labs64.com>
 * @license   Apache-2.0
 * @link      https://netlicensing.io
 * @copyright 2017 Labs64 NetLicensing
 */
const LicenseType = Object.freeze({
  FEATURE: 'FEATURE',
  TIMEVOLUME: 'TIMEVOLUME',
  FLOATING: 'FLOATING',
  QUANTITY: 'QUANTITY',
});

export default LicenseType;
